import { observer } from 'mobx-react-lite'
import { formatJobsTableStatus } from '@/features/jobs/list/jobs-table-status'
import { formattedProgressionStep } from '@/features/jobs/list/jobs-table-columns'
import { type SearchableJob } from '@/features/jobs/list/SearchableJob'
import { type FirmDashboardJobTableViewModel } from '@/features/jobs/dashboard/FirmDashboardJobTableViewModel'
import { PrimaryCellContainer } from '@/features/jobs/list/components/JobManagement/JobsTable/PrimaryCellContainer'
import { FirmDashboardJobsTableRow } from '@/features/jobs/dashboard/components/FirmDashboardJobsTableRow'

export interface FirmDashboardJobsTableRowContainerProps {
  vm: FirmDashboardJobTableViewModel
  job: SearchableJob
}

export const FirmDashboardJobsTableRowContainer = observer(
  function FirmDashboardJobsTableRowContainer({
    vm,
    job,
  }: FirmDashboardJobsTableRowContainerProps) {
    return (
      <FirmDashboardJobsTableRow
        to={vm.getJobLink(job)}
        columnIds={vm.columnsVm.visibleColumnIds}
        id={job.id}
        primaryCell={
          <PrimaryCellContainer
            job={job}
            openTicket={vm.getLatestOpenTicketForJob(job)}
            density="Default"
            testId={`job-title-${job.id}`}
          />
        }
        shortId={job.shortId}
        status={formatJobsTableStatus(job.status, job.resolution)}
        progressionStep={formattedProgressionStep(job)}
        clientTeamName={job.clientTeamName}
        dateSubmitted={job.dateSubmitted}
        testId={'job-list-item-' + job.name}
      />
    )
  },
)
